import { combineReducers } from 'redux'
//import {persistentReducer} from 'redux-pouchdb' // pouchdb
import {
  RECEIVE_ACTIVITY,
  RECEIVE_COMPETENCY,
  RECEIVE_ACTIVITY_ANSWER
} from './actions'

export function activities(state={},action) {
  switch(action.type) {
    case RECEIVE_ACTIVITY:
      action.activity['cps'] = {}
      return Object.assign({}, state, { [action.activityId]: action.activity  })
    case RECEIVE_COMPETENCY:
      const activity = state[action.activityId]
      activity.cps[action.competencyId] = action.competency
      return Object.assign({}, state, { [action.activityId]: activity }   )
    case RECEIVE_ACTIVITY_ANSWER:
      const activity1 = state[action.activityId]
      const dimension = activity1.cps[action.competencyId].dimensions[action.dimensionId]
      if (!dimension.answers) dimension.answers = {}
      dimension.answers[action.answer.indicatorId] = dimension.indicators[action.answer.indicatorId]
      return Object.assign({},state, {[action.activityId]: activity1 })
    default:
      return state
  }
}


const rootReducer = combineReducers({
  activities
})

export default rootReducer
//export default persistentReducer(postsBySubreddit,'postsBySubreddit')


// WEBPACK FOOTER //
// ./src/modules/activities/reducers.js